// AUD10 display-only conversion. Shared model is contract-tested against the account frontend.

const CV_GIFT_HINT_AGE = 30 * 60 * 1000;
function cvReadGiftHint(value, now = Date.now()) {
  if (!value || typeof value !== 'object' || value.v !== 1) return null;
  const {country, currency, rate, observedAt} = value;
  if (typeof country !== 'string' || !/^[A-Z]{2}$/.test(country) ||
      typeof currency !== 'string' || !/^[A-Z]{3}$/.test(currency) ||
      typeof rate !== 'number' || !Number.isFinite(rate) || rate < 0.000001 || rate > 1000000 ||
      !Number.isSafeInteger(observedAt) || observedAt > now + 60000 || now - observedAt > CV_GIFT_HINT_AGE ||
      (currency === 'AUD' && rate !== 1)) return null;
  try {
    if (typeof Intl.supportedValuesOf !== 'function' || !Intl.supportedValuesOf('currency').includes(currency)) return null;
    new Intl.NumberFormat('en-AU', {style: 'currency', currency}).format(10 * rate);
  } catch { return null; }
  return {v: 1, country, currency, rate, observedAt};
}
function cvGiftFormat(value, now = Date.now()) {
  const hint = cvReadGiftHint(value, now);
  const base = {label: 'A$10', currency: 'AUD', estimated: false,
    note: 'A$10 value, converted to your checkout currency. Final savings are shown at checkout.'};
  if (!hint || hint.currency === 'AUD') return base;
  const prefixes = {USD: 'US$', CAD: 'C$', NZD: 'NZ$', SGD: 'S$', HKD: 'HK$', TWD: 'NT$', CNY: 'CN¥', EUR: '€', GBP: '£', JPY: '¥', KRW: '₩', INR: '₹', VND: '₫'};
  const formatter = new Intl.NumberFormat('en-AU', {style: 'currency', currency: hint.currency});
  const parts = formatter.formatToParts(10 * hint.rate);
  const label = parts.filter(part => !(prefixes[hint.currency] && part.type === 'literal' && /^\s*$/.test(part.value)))
    .map(part => part.type === 'currency' && prefixes[hint.currency] ? prefixes[hint.currency] : part.value).join('');
  return {label, currency: hint.currency, estimated: true,
    note: 'Estimated ' + hint.currency + ' equivalent of A$10. Final savings are calculated at checkout.'};
}

(() => {
  const config = document.querySelector('script[data-cv-welcome-currency]');
  if (!config || config.dataset.baseCurrency !== 'AUD') return;
  const observedAt = Date.now();
  function hint() {
    const current = window.Shopify?.currency;
    if (!current || current.active !== config.dataset.currency) return null;
    return cvReadGiftHint({v: 1, country: config.dataset.country, currency: config.dataset.currency,
      rate: Number(Number(current.rate).toFixed(12)), observedAt});
  }
  function decorate(link, value) {
    if (!(link instanceof HTMLAnchorElement)) return;
    let u;
    try { u = new URL(link.href); } catch { return; }
    if (!['https://calvielle-welcome.smfwzc.workers.dev', 'https://account.calvielle.com'].includes(u.origin) ||
        u.username || u.password || !['/', '/account'].includes(u.pathname)) return;
    ['cv_currency', 'cv_country', 'cv_rate', 'cv_at'].forEach(field => u.searchParams.delete(field));
    // Invalid/missing current FX explicitly clears any old account display preference.
    u.searchParams.set('cv_currency', value ? value.currency : 'unavailable');
    if (value) {
      u.searchParams.set('cv_country', value.country);
      u.searchParams.set('cv_rate', String(value.rate));
      u.searchParams.set('cv_at', String(value.observedAt));
    }
    if (link.href !== u.href) link.href = u.href;
  }
  function refresh() {
    const value = hint(), display = {label:'10% OFF',estimated:false,note:'Any quantity · Shipping excluded. One coupon or discount code per order.'};
    document.querySelectorAll('[data-cv-gift-amount]').forEach(node => {
      if (node.textContent !== display.label) node.textContent = display.label;
      node.setAttribute('aria-label', (display.estimated ? 'Estimated ' : '') + display.label);
    });
    document.querySelectorAll('[data-cv-gift-conversion]').forEach(node => {
      if (node.textContent !== display.note) node.textContent = display.note;
    });
    document.querySelectorAll('a[href]').forEach(link => decorate(link, value));
  }
  function follow(event) {
    if (event.target instanceof Element) decorate(event.target.closest('a[href]'), hint());
  }
  refresh();
  document.addEventListener('click', follow, true);
  document.addEventListener('auxclick', follow, true);
  document.addEventListener('contextmenu', follow, true);
  window.addEventListener('pageshow', refresh);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) refresh(); });
  // Header and cart fragments are inserted after the full document is rendered.
  const observer = new MutationObserver(records => {
    if (records.some(record => [...record.addedNodes].some(node => node instanceof Element))) refresh();
  });
  observer.observe(document.body, {childList: true, subtree: true});
})();
